'use client';

import { InfoBox } from '../alert';
import { RichText } from '../rich-text';

import type { PlanPrePositioningMessages } from '@/app/generated/graphql';
import type { Document } from '@contentful/rich-text-types';
import { useJoinFormStore } from '@/stores/join-form-store/join-form-store';

const PlanPrePositioningMessageContent = ({
  messages,
}: {
  messages: PlanPrePositioningMessages[];
}) => {
  const { property, steps, currentStepNumber } = useJoinFormStore();

  //  Hide if no address is in state
  if (!property.address.full) {
    return null;
  }

  const filteredMessages = messages.filter(
    (message) =>
      message.state === property.address.state &&
      steps[currentStepNumber]?.fuel.toLowerCase() === message.energyType?.toLowerCase()
  );

  if (!filteredMessages.length) {
    return null;
  }

  return filteredMessages.map((message) => (
    <div
      key={message._id}
      className="container flex items-center justify-center"
    >
      <InfoBox>
        <div className="flex flex-col gap-a">
          <RichText
            links={message.body?.links}
            document={message.body?.json as Document}
            bodyVariant="body3"
            bodySpacing="small"
          />
        </div>
      </InfoBox>
    </div>
  ));
};

export { PlanPrePositioningMessageContent };
